import { ActivityTypeEnum } from '@sport-activities/sdk';

import { Activity } from '~/core/model/activity.model';

export function checkActivityMandatoryFields(
  activity: Activity,
  mandatoryFields: object
): boolean {
  const ACTIVITY_TYPE = getActivityTypeForMandatoryFields(
    activity,
    mandatoryFields
  );
  return mandatoryFields[ACTIVITY_TYPE].some((propertyName) => {
    return [undefined, null, ''].includes(activity[propertyName]);
  });
}

export function getActivityTypeForMandatoryFields(
  activity: Activity,
  mandatoryFields: object
): ActivityTypeEnum {
  return mandatoryFields[activity.type]
    ? activity.type
    : ('DEFAULT' as ActivityTypeEnum);
}
